//
//
//
//
//
//

export default {
    name: 'PageLoader'
}
